import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';
import PredesComplianceMissingMandatoryElementsReport
  from '../../components/PredesComplianceMissingMandatoryElementsReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesComplianceMissingMandatoryElementsSummarySelectors';

export function PredesComplianceMissingMandatoryElementsSummaryContainer(props) {
  return (
    <PredesComplianceMissingMandatoryElementsReport
      reportId={ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesComplianceMissingMandatoryElementsSummaryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesComplianceMissingMandatoryElementsSummaryContainer);
